import React from 'react';
import { usePromptButton } from '../PromptButton';
import { getIntl } from '../../../utils/intl';
import IconButton from '../../v2BaseComponents/IconButton';
import Text from '../../v2BaseComponents/Text';

const intl = getIntl('help-prompt', {
    help: 'Help',
});

export type HelpPromptOwnProps = {
    message: string;
    title?: string;
};

export type HelpPromptProps = HelpPromptOwnProps;

const HelpPrompt: React.FC<HelpPromptProps> = (props) => {
    const { onPress, Prompt } = usePromptButton({
        renderPromptContents: () => <Text variant="body-1">{props.message}</Text>,
        promptTitle: props.title || intl('help'),
    });

    return (
        <>
            <IconButton icon="HelpCircle" variant="transparent" onPress={onPress} />
            {Prompt}
        </>
    );
};

export default React.memo(HelpPrompt);
